import { useMemo } from 'react';
import type { AssetPermissions, CollectionItem, MediaItem } from '../types';
import type { AssetListViewRow, CollectionListViewRow, ListViewRow } from './listView.types';

function parsePermissions(raw: unknown): AssetPermissions | undefined {
  if (!raw) return undefined;
  try {
    return JSON.parse(raw as string);
  } catch {
    return undefined;
  }
}

export function useListViewData(assetsData: (MediaItem | CollectionItem)[]): ListViewRow[] {
  return useMemo(() => {
    return assetsData.map((item): ListViewRow => {
      const isCollection = item.__typename?.includes('Collection');

      if (isCollection) {
        const collection = item as CollectionItem;
        return {
          id: collection.id,
          __rowType: 'collection',
          collection,
        } satisfies CollectionListViewRow;
      }

      const asset = item as MediaItem;
      return {
        id: asset.id,
        __rowType: 'asset',
        itemId: asset.id,
        name: asset.name,
        permissions: parsePermissions(asset.myAssetPermissions),
        highlights: asset.highlights,
      } satisfies AssetListViewRow;
    });
  }, [assetsData]);
}
